const TotalAsset = resolve => {
    import(/* webpackChunkName: 'totalAsset' */'../views/intro/totalAsset').then(totalAsset => {
        resolve(totalAsset)
    })
}
const Debt = resolve => {
    import(/* webpackChunkName: 'debt' */'../views/intro/debt').then(debt => {
        resolve(debt)
    })
}
const Award = resolve => {
    import(/* webpackChunkName: 'award' */'../views/intro/award').then(award => {
        resolve(award)
    })
}
const Other = resolve => {
    import(/* webpackChunkName: 'totalAsset' */'../views/intro/other').then(other => {
        resolve(other)
    })
}
const FamilyAccount = resolve => {
    import(/* webpackChunkName: 'familyAccount' */'../views/intro/familyAccount').then(familyAccount => {
        resolve(familyAccount)
    })
}
export default [
    {
        path: '/intro/totalAsset',
        name: 'totalAsset',
        component: TotalAsset
    },
    {
        path: '/intro/debt',
        name: 'debt',
        component: Debt
    },
    {
        path: '/intro/award',
        name: 'award',
        component: Award
    },
    {
        path: '/intro/other',
        name: 'other',
        component: Other
    },
    {
        path: '/intro/familyAccount',
        name: 'familyAccount',
        component: FamilyAccount,
        meta: {
            title: '了解家庭账号'
        }
    }
]
